import { Pipe, PipeTransform } from '@angular/core';
import { ICarrier } from "libraries/service/resources/airTrip/IGetAirTripQuotes";
import { ICodeName } from "libraries/service/resources/model/shared/ICodeName";

@Pipe({
    name: 'findCarrier'
})

export class FindCarrierPipe implements PipeTransform {
    public transform(code: string, carriers: ICarrier): string {
        return carriers ? `code (${carriers[code].name})` : code;
    }
}
